var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaseStudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    height: "28px",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    width: "28px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109,43.1V42c0-5.5-4.5-10-10-10H74c-3.3,0-6-3.2-6-6.5V26c0-5.5-4.5-10-10-10H21c-5.5,0-10,4.5-10,10v77  c0,5.5,4.5,10,10,10l0,0h87c5.5,0,10-4.5,10-10V53C118,47.8,114,43.6,109,43.1z M21,109c-3.3,0-6-2.7-6-6V26c0-3.3,2.7-6,6-6h37  c3.3,0,6,2.7,6,6c0,5.5,4.5,10,10,10h25c3.3,0,6,2.7,6,6v1H37c-5.5,0-10,4.5-10,10v50C27,106.3,24.3,109,21,109L21,109z M114,103  c0,3.3-2.7,6-6,6H29c1.3-1.7,2-3.8,2-6V53c0-3.3,2.7-6,6-6h71c3.3,0,6,2.7,6,6V103z",
    fill: "#2C3E50"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudy);
export default __webpack_public_path__ + "static/media/case_study.8a0f4b9a7037a8887a841eeaa2bf8ad1.svg";
export { ForwardRef as ReactComponent };